import MyBeatOut from './MyBeatOut.vue';
export default MyBeatOut;
